import React, { useState } from 'react';
import { CgClose } from "react-icons/cg";
import { toast } from 'react-toastify';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';
import SummaryApi from '../common';
import excelSample from '../assest/excelSample.png'
import { SiMicrosoftexcel } from "react-icons/si";

const UploadMultipleProducts = ({ userType, onClose, fetchData }) => {
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState("لم يتم اختيار اي ملف بعد"); 

  const handleFileUpload = (e) => {
    const selectedFile = e.target.files[0];

    // Check if the selected file is an Excel file
    if (selectedFile && (selectedFile.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || selectedFile.type === "application/vnd.ms-excel")) {
      setFile(selectedFile);
      setFileName(selectedFile.name); // Update file name
    } else {
      toast.error("من فضلك اختر فقط ملف excel"); // Error toast for non-Excel files
      setFile(null);
      setFileName("لم يتم اختيار اي ملف بعد"); // Reset file name
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!file) {
      toast.error("اولا excel من فضلك قم باختيار ملف ");
      return;
    }

    setLoading(true);

    const formData = new FormData();
    formData.append('file', file); // Append the Excel file to FormData
    formData.append('type', userType); // Append userType

    try {
      const response = await fetch(SummaryApi.uploadMultipleProducts.url, {
        method: SummaryApi.uploadMultipleProducts.method,
        credentials: 'include',
        body: formData
      });

      const responseData = await response.json();

      if (responseData.success) {
        toast.success(responseData?.message);
        onClose();
        fetchData();
      } else {
        toast.error(responseData?.message);
      }
    } catch (error) {
      toast.error("تاكد من صحة الببيانات");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='fixed w-full h-full bg-gray-300 bg-opacity-40 top-4 left-0 flex justify-center items-center'>
      <div className='bg-white p-6 rounded-lg w-full max-w-xl shadow-lg'> {/* Increased width here */}
        <div className='flex justify-between items-center mb-4'>
          <h2 className='font-bold text-xl text-gray-800'>رفع العديد من المنتجات</h2>
          <button className='bg-gray-200 hover:bg-red-600 text-gray-800 hover:text-white rounded-full p-2 transition duration-300' onClick={onClose}> {/* Updated button styles */}
            <CgClose className='text-2xl' />
          </button>
        </div>

        {/* Scrollable content container */}
        <div className="max-h-96 overflow-y-auto mb-4 text-right">
          {/* Instructional Note */}
          <div className="bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-4 mb-4" role="alert">
            <p className="font-bold">تنبيه</p>
            <p>: من فضلك قم بادخال الاعمدة بهذه الاسماء لقبول العملية</p>
            
              <li dir="rtl">اسم المنتج</li>
              <li dir="rtl">كود المنتج</li>
              <li dir="rtl">اسم العلامة التجارية</li>
              <li dir="rtl">المادة الفعالة</li>
              <li dir="rtl">السعر</li>
              <li dir="rtl">السعر بعد التخفيض</li>
              <li dir="rtl">الكمية</li>
              <li dir="rtl">شرح تفاصيل المنتج</li>
              <li dir="rtl">حالة المنتج</li>  
              <li dir="rtl">الكمية المطلوبة للوصول للبونص</li> 
              <li dir="rtl">البونص</li>           
    
          </div>

          <div className="bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-4 mb-4" role="alert">
            
            <p  className="font-bold">: يرجي العلم ايضا ان "حالة المنتج" يجب ان يتم وضعها بواحدة من هذة المدخلات الاربعة فقط </p>
            
             
           
              <li className="mt-2 " dir="rtl">      افتراضي  </li>
              
              <li className="mt-2 " dir="rtl">   منتجات حديثة الوصول   </li>
              <li className="mt-2 " dir="rtl">   التخفيضات</li>
              <li className="mt-2 " dir="rtl">  العروض المجمعة</li>

              <li className="mt-2 " dir="rtl">في حالة ان المدخلات غير ذلك سيتم وضع حالة المنتج تلقائيا افتراضي</li>
            
    
          </div>


          <div className="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 mb-4" role="alert">
          <p className="font-bold">ملاحظات هامة</p>
          <li className="mt-2  text-red-600 " dir="rtl">يرجي العلم انه في كل مرة تقوم برفع ملف Excel يتم رفع المنتجات كلها وليس الجديد فقط لذا وجب التنبيه ان اردت رفع منتجات عبر ملف Excel فتاكد انك لم يسبق لك ان رفعتها من قبل (جديدة تمامًا)  </li>
          <li className="mt-2  text-red-600 " dir="rtl">يجب ملئ جميع الخلايا ب مدخلات صحيح  </li>
            <li className="mt-2 text-red-600 " dir="rtl"> في حالة عدم وجود سعر بعد التخفيض ضع قيمة "السعر بعد التخفيض" ب 0 </li>
            <li className="mt-2 text-red-600 " dir="rtl"> يرجي العلم انه في حالة ان السعر بعد التخفيض اعلي من او يساوي السعر الاصلي سيتم محاسبة المنتج بالسعر الاصلي واعتبار انه لا يوجد تخفيض </li>
            <li className="mt-2 text-red-600 " dir="rtl">في حالة عدم وجود بونص ضع قيمة "الكمية المطلوبة للوصول للبونص " و "البونص" ب 0</li>

          </div>
          <div className="mb-4 text-center">
            <img src={excelSample} alt="Sample Excel Format" style={{ maxWidth: '700px' }} className="max-w-full h-auto rounded-lg " />
            <p className="mt-2 text-gray-600 "> Excel مثال على تنسيق ملف </p>
          </div>
        </div>

        <form className='flex flex-col gap-4' onSubmit={handleSubmit}>
          <label htmlFor='file' className='font-medium text-gray-700'>
            <span className='text-red-500'>*</span> الذي تريد تحميله excel قم باختيار ملف
          </label>
          <div className="flex items-center">
          <label
            htmlFor='file'
            className='flex items-center cursor-pointer py-2 px-4 bg-green-600 text-white rounded-md hover:bg-green-700 transition duration-300'
        >
            <SiMicrosoftexcel className="mr-2 text-lg" />
            Excel اختر ملف
        </label>

            <span className='ml-3 text-gray-600'>{fileName}</span>
          </div>

          {/* Hidden file input */}
          <input
            type='file'
            id='file'
            accept='.xlsx, .xls' // Accept only Excel file types
            onChange={handleFileUpload}
            className='hidden'
            required
          />

          <button
            type='submit'
            className={`w-full py-2 px-4 text-lg font-medium rounded-md ${loading ? 'bg-blue-300 cursor-not-allowed' : 'bg-blue-900 hover:bg-blue-700 transition duration-300'} text-white`}
            disabled={loading}
          >
            {loading ? (
              <span className='flex justify-center items-center'>
                <AiOutlineLoading3Quarters className='animate-spin mr-2' />
                جاري إضافة المنتجات...
              </span>
            ) : 'اضف المنتجات الجديدة'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default UploadMultipleProducts;
